export const parseSignedFinancialNumber = (value) => {
  if (value == null || value === "") return null;
  const num = typeof value === "number" ? value : parseFloat(value);
  return Number.isNaN(num) ? null : num;
};

/** Tailwind text color: positive = green, negative = red, zero/null = neutral. */
export const signedFinancialColorClass = (
  value,
  { neutralClass = "text-slate-600" } = {}
) => {
  const num = parseSignedFinancialNumber(value);
  if (num == null || num === 0) return neutralClass;
  if (num > 0) return "text-green-600";
  return "text-red-600";
};
